import React from 'react'

export default function DataItem (props) {
  return (
    <div className={'data-item ' + props.cls}>
      <p className='data-item__title'>{props.title}</p>
      <p className='data-item__text'>{props.text}</p>
    </div>
  )
}
